import React from "react";
import SEO from "@/components/SEO";
import ServiceLocationTemplate from "@/components/ServiceLocationTemplate";

const BroadmeadowsEmergencyDentistPage = () => (
  <ServiceLocationTemplate suburbName="Broadmeadows" suburbSlug="broadmeadows" variant="emergency-dentist" />
);

export default BroadmeadowsEmergencyDentistPage;
